import {Component, Input} from '@angular/core';
import {InputBase} from '../input-base';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'cmp-input-radio',
  template: `<!--INPUT BY MODEL-->
<input [type]="'radio'"
       *ngIf="!control"
       [(ngModel)]="model"
       [name]="name || null"
       (ngModelChange)="outputModel()"
       [disabled]="isDisabled || null"
       [id]="nameId"
       [value]="value"
       [checked]="checked"><label *ngIf="_label && !control" [for]="value">{{_label}}</label><br>
<!--INPUT BY CONTROL-->
<input [type]="'radio'"
       *ngIf="control"
       [formControl]="control"
       [name]="name || null"
       (ngModelChange)="outputModel()"
       [disabled]="isDisabled || null"
       [id]="nameId"
       [value]="value"
       [checked]="checked"><label *ngIf="_label && control" [for]="value">{{_label}}</label>
`,
  styles: [`.form-control-xs{height:27px;font-size:14px;padding-left:5px}`]
})
export class InputRadioComponent extends InputBase {

  @Input() control: FormControl;
  @Input() checked = false;
  @Input() value = '';

  constructor() {
    super();
  }
}
